import { notification } from 'antd';
import moment from 'moment';

import apiDatalake from '../services/apiDatalake';

export const buscarHistorico = async (
  produto,
  ibgeCidadeOrigem,
  ibgeCidadeDestino,
  inicioPeriodo = moment([2018, 0, 1]),
  finalPeriodo = moment()
) => {
  if (!ibgeCidadeOrigem && !ibgeCidadeDestino) return;

  try {
    const { data } = await apiDatalake.post('/buscar-calculadora-frete', {
      ibgeCidadeOrigem,
      ibgeCidadeDestino,
      inicioPeriodo: moment(inicioPeriodo).format('X'),
      finalPeriodo: moment(finalPeriodo).format('X'),
      ...(produto !== '' && { produtos: [produto] }),
    });

    return {
      mediaAtualFrete: data.media_atual_frete,
      mediaAtualFreteConcorrente: data.media_atual_frete_concorrente,
      mediaHistoricaFrete: data.media_historica_frete,
      mediaHistoricaFreteConcorrente: data.media_historica_frete_concorrente,
    };
  } catch (e) {
    notification.error({
      message: 'Ops não foi possível buscar o histórico da rota.',
      description:
        'Se o problema persistir por favor entre em contato com o suporte.',
    });
    return null;
  }
};
